<section class="header">
    <div class="d-flex justify-content-between align-items-center" aria-level="1">
        <h1 class="flex-2" id="all-users-progress-header">
            <status-indicator *ngIf="selectedTab === 'compliance'" [statusId]="userStatusSummary?.OverallUserStatus ?? CplUserStatus.DEFAULT"></status-indicator>
            {{ user?.LastName }}, {{ user?.FirstName }}
        </h1>
        <div id="user-summary-groups-act-48-PERMS" class="flex-1 nav col-sm-6 d-flex justify-content-end" *ngIf="portalSettings?.Act48Enabled && !user?.Archived">
            <a class="nav-link" href="https://www.perms.pa.gov" target="_blank" rel="noopener" aria-label="Act 48 PERMS (opens in new window)">
                <i class="fas fa-external-link-alt" aria-hidden="true"></i> Act 48 PERMS
            </a>
        </div>
        <button *edlFeatureFlags="EdlFeatureFlags.UsersCanArchiveSelf; ifCondition: canArchiveSelf" class="btn btn-danger" (click)="archiveSelf()">
            Stop Volunteering
        </button>
    </div>
    <div class="d-flex justify-content-between groups-and-packets user-summary-container flex-wrap">
        <div id="user-summary-groups" class="flex-1">
            <div>
                <label>
                    <a *ngIf="canViewUserProfile; else unlinkedGroupLabel" 
                        uiSref="authenticated.users.user.edit" 
                        [uiParams]="{ userId: user?.UserID, step: UserFormNavigation.GROUPS }">
                        Groups:
                    </a>
                    <ng-template #unlinkedGroupLabel>
                        <span #unlinkedGroupLabel>Groups:</span>
                    </ng-template>
                </label>
                <br />
                <span *ngIf="(groups[EDLGroupType.GROUP]?.length ?? 0) === 0" class="base-groups">None</span>
                <span *ngFor="let group of groups[EDLGroupType.GROUP]; let isLast=last" class="base-groups">
                    {{group.GroupName}}{{isLast ? '' : ', '}}
                </span>
            </div>
            <div *edlFeatureFlags="EdlFeatureFlags.VolunteersEnabled" class="mt-2">
                <label>
                    <a *ngIf="canViewUserProfile; else unlinkedVolunteerAreaLabel" 
                        uiSref="authenticated.users.user.edit"
                        [uiParams]="{ userId: user?.UserID, step: UserFormNavigation.VOLUNTEER_AREAS }">
                        Volunteer Areas:
                    </a>
                    <ng-template #unlinkedVolunteerAreaLabel>
                        <span #unlinkedVolunteerAreaLabel>Volunteer Areas:</span>
                    </ng-template>
                </label>
                <br />
                <span *ngIf="(groups[EDLGroupType.VOLUNTEER_AREA]?.length ?? 0) === 0">None</span>
                <span *ngFor="let group of groups[EDLGroupType.VOLUNTEER_AREA]; let isLast=last">
                    {{group.GroupName}}{{isLast ? '' : ', '}}
                </span>
            </div>
        </div>
        <div *ngIf="canViewItemPackets" class="flex-2 item-packet-container">
            <div class="mb-2">
                <label>Item Packets (In Compliance):</label>
                <div class="d-flex flex-wrap align-items-center">
                    <item-packet-pills [userEntries]="compliantItemPackets" [showTitle]="true"></item-packet-pills>
                </div>
            </div>
            <br />
            <div>
                <label>Item Packets (Out of Compliance):</label>
                <div class="d-flex flex-wrap align-items-center">
                    <item-packet-pills [userEntries]="nonCompliantItemPackets" [showTitle]="true"></item-packet-pills>
                </div>
            </div>
        </div>
    </div>
    <div id="user-summary-archived" class="mt-4 mb-4" *ngIf="user.Archived">
        <div class="alert alert-warning mb-0" >User archived on {{user.ArchivedDate! | dateExtended: 'MM/dd/yyyy'}}</div>
    </div>  
</section>

<div class="all-users-progress-tabs">
  <div role="tablist" aria-label="Item Tabs">
        <button
            *ngIf="canViewComplianceItems"
            id="compliance-tab"
            type="button"
            role="tab"
            [attr.aria-selected]="selectedTab === 'compliance'"
            [attr.aria-controls]="'compliance-tabpanel'"
            [class.active]="selectedTab === 'compliance'"
            (click)="selectTab('compliance')"
            (keydown)="onTabKeydown($event, 'compliance')"
            [attr.tabindex]="selectedTab === 'compliance' ? '0' : '-1'"
        >
            <span>Compliance Items</span>
        </button>
        <button
            id="requests-tab"
            type="button"
            role="tab"
            [attr.aria-selected]="selectedTab === 'requests'"
            [attr.aria-controls]="'requests-tabpanel'"
            [class.active]="selectedTab === 'requests'"
            (click)="selectTab('requests')"
            (keydown)="onTabKeydown($event, 'requests')"
            [attr.tabindex]="selectedTab === 'requests' ? '0' : '-1'"
        >
            <span>Requests</span>
        </button>
  </div>
</div>

<div class="all-users-progress-content">
    <div *ngIf="isLoading" class="all-users-progress-tab-loading" aria-busy="true" aria-live="polite">
        <div class="loaderContainer loader"></div>
    </div>
    <div *ngIf="!isLoading">
        <ui-view name="all-users-progress-tab" [attr.aria-labelledby]="selectedTab + '-tab'"></ui-view>
    </div>
</div>
